import { ISubmissionFile } from '@publishing-engine/domain/models';
import { ISubmissionFieldsResponse } from '@publishing-engine/submission-service/src/usecases/submission-fields/types';

/**
 * Calculate the total number of files in a file array
 */
export const getFileListCount = (files?: ISubmissionFile[]): number => {
  if (!files || !Array.isArray(files)) {
    return 0;
  }
  return files.length;
};

// File fields rendered in the review "Files" section.
const REVIEW_FILE_FIELDS = [
  'Manuscript',
  'TitlePage',
  'CompleteDocumentForReview',
  'AnonymizedManuscript',
  'Supplementary',
  'AdditionalSupplementary',
  'Figures',
  'Tables'
] as const;

/**
 * Calculate the total number of files in the review "Files" section.
 * Single-file fields count as 1; multi-file fields (and figures/tables)
 * count by their array length.
 */
export const countReviewFiles = (fields: ISubmissionFieldsResponse): number =>
  REVIEW_FILE_FIELDS.reduce((total, name) => {
    const value = fields[name]?.value;
    if (!value) return total;
    return total + (Array.isArray(value) ? value.length : 1);
  }, 0);
